import usePPMessage from './usePPMessage';

export default usePPMessage;
